var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3333 29.0003C7.79999 29.0003 1.66666 22.867 1.66666 15.3337C1.66666 7.80032 7.79999 1.66699 15.3333 1.66699C15.88 1.66699 16.3333 2.12033 16.3333 2.66699C16.3333 3.21366 15.88 3.66699 15.3333 3.66699C8.89332 3.66699 3.66666 8.90699 3.66666 15.3337C3.66666 21.7603 8.89332 27.0003 15.3333 27.0003C21.7733 27.0003 27 21.7603 27 15.3337C27 14.787 27.4533 14.3337 28 14.3337C28.5467 14.3337 29 14.787 29 15.3337C29 22.867 22.8667 29.0003 15.3333 29.0003ZM18.6667 7.66699H26.6667C27.2133 7.66699 27.6667 7.21366 27.6667 6.66699C27.6667 6.12033 27.2133 5.66699 26.6667 5.66699H18.6667C18.12 5.66699 17.6667 6.12033 17.6667 6.66699C17.6667 7.21366 18.12 7.66699 18.6667 7.66699ZM18.6667 11.667H22.6667C23.2133 11.667 23.6667 11.2137 23.6667 10.667C23.6667 10.1203 23.2133 9.66699 22.6667 9.66699H18.6667C18.12 9.66699 17.6667 10.1203 17.6667 10.667C17.6667 11.2137 18.12 11.667 18.6667 11.667ZM28.6266 30.0409C28.8267 30.2409 29.08 30.3342 29.3333 30.3342C29.5867 30.3342 29.84 30.2409 30.04 30.0409C30.4267 29.6542 30.4267 29.0142 30.04 28.6276L27.3733 25.9609C26.9867 25.5742 26.3466 25.5742 25.96 25.9609C25.5733 26.3476 25.5733 26.9876 25.96 27.3742L28.6266 30.0409Z",
    fill: "url(#paint0_linear_1668_27497)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1668_27497",
    x1: -3.11056,
    y1: 1.66699,
    x2: 30.3339,
    y2: 30.3297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CFFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706855,
    stopColor: "#185B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021744"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchStatus);
export default __webpack_public_path__ + "static/media/search-status.c84790a390cfb0488e5c2590c1230b4e.svg";
export { ForwardRef as ReactComponent };